import type { SVGProps } from "react";

const IconCopy = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="0.8em"
      height="0.8em"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.45485 2.70062H0.841278C0.376051 2.70062 0 3.07667 0 3.5419V11.778C0 12.2432 0.376051 12.6193 0.841278 12.6193H8.45737C8.9226 12.6193 9.29865 12.2432 9.29865 11.778V3.5419C9.29697 3.07667 8.91923 2.70062 8.45485 2.70062ZM8.1747 11.4979H1.12142V3.82205H8.17723V11.497H8.1747V11.4979Z"
        fill="currentColor"
      />
      <path
        d="M10.5074 0H3.06797C2.75922 0 2.50684 0.252384 2.50684 0.561133C2.50684 0.869882 2.75922 1.12227 3.06797 1.12227H10.5074C10.7118 1.12227 10.8776 1.288 10.8776 1.49243V9.86063C10.8776 10.1694 11.1299 10.4218 11.4387 10.4218C11.7474 10.4218 11.9998 10.1694 11.9998 9.86063V1.49159C11.9973 0.667134 11.3293 0 10.5082 0H10.5074Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconCopy;
